module.exports = __webpack_public_path__ + "img/sld_scb_14_t1_b1.dca314a4.svg";